export default class Overdue {
  //业务组
  businessGroup:string;
  //单证
  ownerName:string;
  //客户
  customerName:string;
  //客户
  shippingNumber:string;
  //出运日
  shipmentDate:string;
  //逾期金额
  overdueAmount:string;
  //付款方式
  payment:string;
  //应付款日
  prePaymentDate:string;
  //逾期天数
  overdueDays:string;
  //销售类型
  salesType:string;
  //币种
  currency:string;
}